<div *ngIf="!isLink" class="itb-chip">
    <mat-chip ngClass="{{className}}" matTooltip="{{tooltipText}}" (click)="clickEvent()"><span class="chip-text">{{text}}</span><span class="add-ico">+</span> </mat-chip>
</div>

<div *ngIf="isLink" class="itb-chip">
        <a routerLink="{{link}}"><mat-chip ngClass="{{className}}" matTooltip="{{tooltipText}}" (click)="clickEvent()"><span class="chip-text">{{text}}</span><span class="add-ico">+</span> </mat-chip></a>
</div>